export default __webpack_public_path__ + "static/media/postcard_front.a7f5aa82.jpg";